import * as React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import { getAuth, onAuthStateChanged} from 'firebase/auth';
import { db } from './../firebase-config';
import { collection, getDoc, setDoc, addDoc, serverTimestamp, doc } from 'firebase/firestore';


import HeaderBack from './common/HeaderBack';
import Avatar from '@mui/material/Avatar';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import Button from '@mui/material/Button';
import UploadImg from './common/UploadImg';

export default function PostCreateForm(){
	const [meow,setMeow] = useState("");
	const [save,setSave] = useState(true);
	
	let navigate = useNavigate();

	
	useEffect(() => {
		let authToken = sessionStorage.getItem("Auth Token");
		
		if(meow != ''){
			setSave(false);
		}
		if( meow == ''){
			setSave(true);
		}
		if(authToken){
			navigate('/postcreateform')
		}
		
		if(!authToken){
			navigate('/')
		}
	}, [meow])
	
	const handleSave = (e) => {
		try{
			e.preventDefault();
			
			const auth = getAuth();
			
			onAuthStateChanged(auth, (user) => {
				
				if(user){
					
				const createmeow = async () => {

					await setDoc(doc(db, "users", user.uid, "meows", "meow1"), {
						post: meow, 
						createdAt: serverTimestamp(),
						});
					}
			
					createmeow();
					alert("Meow");
				}});
				navigate('/home')
			
		}catch(e) {
		console.log("error adding doc:", e);
		alert('Changes not added');
		}
	}
	
	return(
		<>
			<HeaderBack /> 
			<main>
			<article className="create-post">
				<Avatar alt="Remy Sharp" src="https://source.unsplash.com/random/girl" sx={{ width: 60, height: 60 }} />
				<TextareaAutosize
				aria-label="minimum height"
				minRows={4}
				placeholder="What's Happening?"
				style={{ width: '100%', padding: 15, border: "none" }}
				onChange={(e) => setMeow(e.target.value)}
				/>
			</article>
			<hr style={{ color: '#ab47bc' }} />

			<UploadImg />
			<Button  variant="contained"  disabled={save} onClick={handleSave} sx={{width: "100%", mt:"2rem", p: "0.8rem"}}>Meow Post</Button>
			
			</main>
		</>
	);
}